import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './layout-components/header/header.component';
import { SidebarComponent } from './layout-components/sidebar/sidebar.component';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { SharedModule } from '@app/shared/shared.module';
import { httpInterceptorProviders } from './interceptors';
import { ParentsLayoutComponent } from './layouts/parents-layout/parents-layout.component';
import { NosidebarLayoutComponent } from './layouts/nosidebar-layout/nosidebar-layout.component';
import { OptionalHeaderLayoutComponent } from './layouts/optional-header-layout/optional-header-layout.component';

/**
 * This module contains services that may be used everywhere in the project and services that don't fit to any other module.
 * Also it may contain other injectables (like guards and interceptors)
 * and declarations (declarations that are ONLY used in the AppModule or this module).
 *
 * Do NOT import this module in other modules (except for the AppModule).
 */
@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    DefaultLayoutComponent,
    LoginLayoutComponent,
    ParentsLayoutComponent,
    NosidebarLayoutComponent,
    OptionalHeaderLayoutComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    // Components that are used outside of this module
  ],
  providers: [
    httpInterceptorProviders
  ]
})
export class CoreModule { }
